import { create } from 'zustand'
import { ProjectStageSingleT } from '@/components/common/menu/lib/types/navigationDataTypes.ts'
import {
  OrgProjectsT,
  ProjectByStatusEntryT,
  SelectedProjectsTabT,
} from '@/routes/settings/projects/lib/projectsTypes.ts'
import {
  OrderFilterT,
  SortByFilterT,
} from '@/routes/projectStages/issues/lib/hooks/useActiveFilters.ts'
import { sortProjects } from '@/routes/settings/projects/lib/helpers/sortProjects.ts'

type ProjectsStoreT = {
  orgProjects: OrgProjectsT | null
  userProjects: ProjectStageSingleT[] | null
  filteredCount: number
  userProjectsByStatus: ProjectByStatusEntryT[]
  orgProjectsByStatus: ProjectByStatusEntryT[]
  selectedProjects: ProjectStageSingleT[] | OrgProjectsT[] | null
  projectsFilterVal: string

  setProjectsFilterVal: (val: string) => void
  setFilteredCount: (filteredCount: number) => void
  setOrgProjectsByStatus: (projectsByStatus: ProjectByStatusEntryT[]) => void
  setUserProjectsByStatus: (projectsByStatus: ProjectByStatusEntryT[]) => void
  setOrgProjects: (orgProjects: OrgProjectsT | null) => void
  setUserProjects: (userProjects: ProjectStageSingleT[] | null) => void
  selectedTabVal: SelectedProjectsTabT
  setSelectedTabVal: (selectedTabVal: SelectedProjectsTabT) => void

  // filterSelectedProjects: (searchValue: string) => void
  setSelectedProjects: (selectedProjects: ProjectStageSingleT[] | OrgProjectsT[] | null) => void
  sortSelectedProjects: (sortBy?: SortByFilterT, order?: OrderFilterT) => void

  dialogOpened: boolean
  setDialogOpened: (state: boolean) => void
}

export const useProjectsStore = create<ProjectsStoreT>(set => ({
  orgProjects: null,
  userProjects: null,
  filteredCount: 0,
  selectedTabVal: 'USER',
  userProjectsByStatus: [],
  orgProjectsByStatus: [],
  selectedProjectsByStatus: [],
  selectedProjects: null,
  projectsFilterVal: '',

  setProjectsFilterVal: projectsFilterVal => set({ projectsFilterVal }),
  setFilteredCount: filteredCount => set({ filteredCount }),
  setSelectedProjects: selectedProjects => set({ selectedProjects }),
  setOrgProjectsByStatus: orgProjectsByStatus => set({ orgProjectsByStatus }),
  setUserProjectsByStatus: userProjectsByStatus => set({ userProjectsByStatus }),
  setSelectedTabVal: selectedTabVal => set({ selectedTabVal }),
  setOrgProjects: orgProjects => set({ orgProjects }),
  setUserProjects: userProjects => set({ userProjects }),
  sortSelectedProjects: (sortBy?: SortByFilterT, order?: OrderFilterT) =>
    set(state => {
      // console.log(`sorting`, sortBy, order)
      const userProjectsByStatusSorted: ProjectByStatusEntryT[] = state?.userProjectsByStatus?.map(
        status => {
          if (status[1].length === 0) return status
          const sorted = sortProjects(status[1], sortBy, order)
          return [status[0], sorted]
        },
      )

      const orgProjectsByStatusSorted: ProjectByStatusEntryT[] = state?.orgProjectsByStatus?.map(
        status => {
          if (status[1].length === 0) return status
          const sorted = sortProjects(status[1], sortBy, order)
          return [status[0], sorted]
        },
      )

      return {
        userProjectsByStatus: userProjectsByStatusSorted,
        orgProjectsByStatus: orgProjectsByStatusSorted,
      }
    }),

  // dialog
  dialogOpened: false,
  setDialogOpened: dialogOpened =>
    set({
      dialogOpened: dialogOpened,
    }),
}))
